import { signalStore } from '@ngrx/signals';
import { AbstractQueryParams, OffSubscriptionWithCatch, withActions, withSelectors } from '@res/ngg-core';
import { InvoiceData, InvoiceModel, InvoiceRef } from '../../schema/schema.interface';
import { InvoiceActions } from './invoice.action';
import { InvoiceState } from './invoice.state';

export type InvoiceStoreModel = InvoiceData & { ref: InvoiceRef };
export interface InvoiceStateModel {
  invoices: InvoiceStoreModel[];
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean;
  filter?: { query: AbstractQueryParams<InvoiceModel>[] };
}

export const InvoiceStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    invoices: InvoiceState.invoices,
    invoiceState: InvoiceState.invoiceState,
  }),
  // Actions
  withActions({
    initInvoices: InvoiceActions.InitInvoices,
    updateInvoice: InvoiceActions.UpdateInvoice,
    getAllInvoices: InvoiceActions.GetAllInvoice,
    queryInvoice: InvoiceActions.QueryInvoice,
  }),
);
